// extracted by mini-css-extract-plugin
module.exports = {"icon":"TitleIcon_icon__2faE7","light":"TitleIcon_light__3grDN"};